import React, { useMemo } from "react";
import {
  Box,
  FormControlLabel,
  Radio,
  Tooltip,
  Typography,
  useTheme,
} from "@mui/material";
import * as f from "../../utils/formatter";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faTimer,
  faPause,
  faChairOffice,
} from "@fortawesome/pro-solid-svg-icons";

function EmployeeLabel({ employee }) {
  const theme = useTheme();

  const breakTimesFromNow = useMemo(
    () =>
      employee.breaks?.map((b) => {
        const now = new Date();
        const start = new Date(b.from);

        //break is in the future, return time to the beginning in minutes
        if (start - now > 0) return Math.floor((start - now) / 1000 / 60);

        const end = new Date(b.to);
        //break is in the progress, return 0
        if (start - now < 0 && end - now > 0) return 0;

        //break already ended, return time from the end in negative minutes
        return Math.floor((start - end) / 1000 / 60);
      }),
    [employee],
  );

  return (
    <>
      <strong>{f.fullName(employee)}</strong>
      <Tooltip title="na křesle" placement="right">
        <FontAwesomeIcon
          color={theme.palette.primary.main}
          icon={faChairOffice}
          style={{ marginRight: "0.5rem", marginLeft: "1rem" }}
        />
        {f.minutesToDuration(employee.time_spent)}
      </Tooltip>

      <Tooltip title="od posledního úkonu" placement="right">
        <FontAwesomeIcon
          color={theme.palette.primary.main}
          icon={faTimer}
          style={{ marginRight: "0.5rem", marginLeft: "1rem" }}
        />
        {f.minutesToDuration(employee.since_last)}
      </Tooltip>

      {breakTimesFromNow.filter((v) => v > 0).length > 0 && (
        <Tooltip
          title={`za ${f.minutesToDuration(breakTimesFromNow.filter((v) => v > 0)[0])} má naplánovanou pauzu`}
          placement="right"
        >
          <FontAwesomeIcon
            color={theme.palette._components.alert.error.color}
            icon={faPause}
            style={{ marginRight: "0.5rem", marginLeft: "1rem" }}
          />
          {f.minutesToDuration(breakTimesFromNow.filter((v) => v > 0)[0])}
        </Tooltip>
      )}
    </>
  );
}

export default function NurseGroup({ label, nurses }) {
  if ((nurses?.length ?? 0) === 0) {
    return null;
  }

  return (
    <Box sx={{ mb: 2 }}>
      <Typography variant="h4" sx={{ mb: 2 }}>
        {label}
      </Typography>

      {nurses.map((o) => {
        return (
          <Box key={o.id} sx={{ mb: 1 }}>
            <FormControlLabel
              value={o.id}
              control={<Radio />}
              label={<EmployeeLabel employee={o} />}
            />
          </Box>
        );
      })}
    </Box>
  );
}
